import { useContext, useEffect, useState } from "react";
import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import axios from "axios";
import { api } from "methods/api";
import { imgPath } from "methods/img";
import { homeContext } from "pages/HomeContext";
import { HardProductsType } from "types/HardProducts";
import { Category } from "types/Root";
import { LocalNavLink } from "hooks/useLocalNavigate";
import { useTranslation } from "react-i18next";

function HurghadaPage() {
  const [t] = useTranslation();
  const { homeData } = useContext(homeContext);
  const categories: Category[] = homeData?.Categories ?? [];
  const [selectedId, setSelectedId] = useState<string | undefined>();
  const [products, setProducts] = useState<HardProductsType | undefined>();
  const [loading, setLoading] = useState(false);

  // أول تصنيف يتفتح تلقائي
  useEffect(() => {
    if (!selectedId && categories.length) {
      setSelectedId(String(categories[0].id));
    }
  }, [categories, selectedId]);

  useEffect(() => {
    if (!selectedId) return;
    setLoading(true);
    axios
      .get<{ data: HardProductsType }>(api(`products/${selectedId}`))
      .then(({ data }) => setProducts(data.data))
      .catch((e) => console.log("error", e))
      .finally(() => setLoading(false));
  }, [selectedId]);

  return (
    <Stack sx={{ py: 8 }}>
      <Typography
        variant="h3"
        sx={{ textAlign: "center", fontWeight: 700, mb: 6, color: "primary.main" }}
      >
        {t("main.Products", "Products")}
      </Typography>

      <Container>
        {/* أزرار التصنيفات (فلتر) */}
        <Grid container spacing={1.5} sx={{ mb: 5 }}>
          {categories.map((cat) => {
            const active = String(cat.id) === selectedId;
            return (
              <Grid item xs={6} md={3} key={cat.id}>
                <Box
                  onClick={() => setSelectedId(String(cat.id))}
                  sx={{
                    p: 2,
                    textAlign: "center",
                    borderRadius: "10px",
                    cursor: "pointer",
                    fontWeight: 700,
                    color: "#fff",
                    backgroundColor: "primary.main",
                    opacity: active ? 1 : 0.75,
                    outline: active ? "3px solid #F19B02" : "none",
                    transition: "all .3s",
                    "&:hover": { opacity: 1 },
                  }}
                >
                  {cat.title}
                </Box>
              </Grid>
            );
          })}
        </Grid>

        {/* صور المنتجات */}
        {loading ? (
          <Typography sx={{ textAlign: "center" }}>...</Typography>
        ) : (
          <Grid container spacing={2}>
            {products?.products?.map((card) => (
              <Grid item xs={12} sm={6} md={3} key={card.id}>
                <Box
                  component={LocalNavLink}
                  to={`/project/${card.id}`}
                  sx={{
                    display: "block",
                    position: "relative",
                    overflow: "hidden",
                    borderRadius: "10px",
                    height: "250px",
                    "&:hover img": { transform: "scale(1.1)" },
                  }}
                >
                  <img
                    src={imgPath(card.images?.[0]?.image)}
                    alt={card.title ?? ""}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transition: "all .5s",
                      display: "block",
                    }}
                  />
                  <Typography
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      width: "100%",
                      textAlign: "center",
                      color: "#fff",
                      fontWeight: 700,
                      p: 1,
                      background: "rgba(0,0,0,.55)",
                    }}
                  >
                    {card.title}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        )}

        {/* لينك لصفحة التصنيف الكاملة */}
        {selectedId && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
            <Typography
              component={LocalNavLink}
              to={`/projects/${selectedId}`}
              sx={{
                borderRadius: "10px",
                backgroundColor: "primary.main",
                color: "#fff",
                p: "9px 24px",
                fontWeight: 700,
              }}
            >
              {t("main.ReadMore")}
            </Typography>
          </Box>
        )}
      </Container>
    </Stack>
  );
}

export default HurghadaPage;